<template>
    <div>
        <el-row class="mb-20">
            <el-col :span="24">
            <el-table
            :data="filteredValue"
            border
            stripe
            style="width: 100%"
            class="item-table hidden-sm-and-down"
          >
            <el-table-column width="180" align="left">
             <!-- eslint-disable-next-line vue/no-unused-vars -->
            <template slot="header" slot-scope="scope" >
              <el-input
                v-model="search"
                size="mini"
                placeholder="Full Name"/>
            </template>
            <template slot-scope="scope">
              <span class="break-word">
                {{ scope.row.firstName }} {{ scope.row.lastName }}
              </span>
            </template>
            </el-table-column>
            <el-table-column
              label="Home Team"
              width="180"
              class-name="break-word"
            >
              <template slot-scope="scope">
                <span class="word-break">
                  {{ scope.row.homeTeam.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Away Team"
              width=auto
            >
              <template slot-scope="scope">
                <span class="word-break">
                  {{ scope.row.awayTeam.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Date/Time"
              width=auto
            >
            <template slot-scope="scope">
              <span>
                {{moment(scope.row.dateTime).format('MM/DD/YYYY')}}
                {{moment(scope.row.dateTime).format('h:mm A')}}
              </span>
            </template>
            </el-table-column>
              <el-table-column  width="180">
                 <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot="header" slot-scope="scope" >
                  <el-select
                    v-model="search2"
                    size="mini"
                    placeholder="Status">
                    <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status !== 'pending'"
                    :type="scope.row.status === 'confirmed' ? 'success' : 'danger'"
                    >{{ scope.row.status | cap }}
                    </el-tag>
                    <el-select v-if="scope.row.status === 'pending'" v-model="scope.row.status" @change="handleUpdateStatus(scope.row)">
                        <el-option
                        v-for="item in status.filter(item => item.value !== 'all')"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </template>
            </el-table-column>
          </el-table>
            <el-table
            :data="value.filter(item => (
              !search
              || item.firstName.toLowerCase().includes(search.toLowerCase())
              || item.lastName.toLowerCase().includes(search.toLowerCase())
              )
            &&
            (
              !search2
              || search2.toLowerCase() === 'all'
              || item.status.toLowerCase().includes(search2.toLowerCase())
            )
            )"
            border
            stripe
            style="width: 100%"
            class="item-table hidden-md-and-up"
          >
            <el-table-column width="180" align="left">
             <!-- eslint-disable-next-line vue/no-unused-vars -->
            <template slot="header" slot-scope="scope" >
              <el-input
                v-model="search"
                size="mini"
                placeholder="Full Name"/>
            </template>
            <template slot-scope="scope">
              <span class="break-word">
                {{ scope.row.firstName }} {{ scope.row.lastName }}
              </span>
            </template>
            </el-table-column>
            <el-table-column
              prop="homeTeam.name"
              label="Home Team"
              width="180"
              class-name="break-word"
            ></el-table-column>
            <el-table-column
              prop="awayTeam.name"
              label="Away Team"
              width=180
            ></el-table-column>
            <el-table-column
              label="Date/Time"
              min-width=180
            >
            <template slot-scope="scope">
              <span>
                {{moment(scope.row.dateTime).format('MM/DD/YYYY')}}
                {{moment(scope.row.dateTime).format('h:mm A')}}
              </span>
            </template>
            </el-table-column>
            <el-table-column  width="180">
                 <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot="header" slot-scope="scope" >
                  <el-select
                    v-model="search2"
                    size="mini"
                    placeholder="Status">
                    <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status !== 'pending'"
                    :type="scope.row.status === 'confirmed' ? 'success' : 'danger'"
                    >{{ scope.row.status | cap }}
                    </el-tag>
                    <el-select v-if="scope.row.status === 'pending'" v-model="scope.row.status" @change="handleUpdateStatus(scope.row)">
                        <el-option
                        v-for="item in status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </template>
            </el-table-column>
          </el-table>
      </el-col>
    </el-row>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'RefereeAppointedTable',
  props: ['value'],
  data() {
    return {
      status: [{
        value: 'confirmed',
        label: 'Confirm'
      }, {
        value: 'declined',
        label: 'Decline'
      },
      {
        value: 'pending',
        label: 'Pending'
      },
      {
        value: 'all',
        label: 'All'
      }],
      search: '',
      search2: ''
    };
  },
  methods: {
    handleUpdateStatus(val) {
      if (val.status === 'confirmed') {
        this.$confirm('Are you sure to confirm this appointment?', 'Confirm', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.$emit('update-status', val);
          this.$message({
            type: 'success',
            message: 'Appointment confirmed'
          });
        }).catch(() => {
          // eslint-disable-next-line no-param-reassign
          val.status = 'pending';
          this.$message({
            type: 'info',
            message: 'Canceled'
          });
        });
      }
      if (val.status === 'declined') {
        this.$confirm('Are you sure to decline this appointment?', 'Decline', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.$emit('update-status', val);
          this.$message({
            type: 'success',
            message: 'Appointment declined'
          });
        }).catch(() => {
          // eslint-disable-next-line no-param-reassign
          val.status = 'pending';
          this.$message({
            type: 'info',
            message: 'Canceled'
          });
        });
      }
    }
  },
  computed: {
    filteredValue() {
      const filtered = this.value.filter((item) => {
        const fullName = `${item.firstName} ${item.lastName}`.toLowerCase().split(' ');
        const searchArr = this.search.toLowerCase().split(' ');
        return (
          !this.search
              || searchArr.every((word) => fullName.some((name) => name.includes(word)))
        )
            && (
              !this.search2
              || this.search2.toLowerCase() === 'all'
              || item.status.toLowerCase().includes(this.search2.toLowerCase())
            );
      });
      return filtered;
    }
  },
  filters: {
    cap(val) {
      return _.capitalize(val);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);
  text-align: center;

  th {
    background: #f6f8fa !important;
    padding-left: 1em;
    padding-right: 1em;
  }

  td {
    background-color: white !important;
    padding: 2em 1em;
  }
}

.word-break {
  word-break: break-word !important;
}

</style>
